<template>
  <el-card class="main-card-config">
    <div v-loading="loading">
      <div class="title-header">
        {{ $t('config-manager::operate-config::title-header') }}
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            <div style="width: 220px">{{ $t('config-manager::operate-config::title-tip') }}</div>
          </div>
          <i class="icon-a-01wenhao iconfont-el icon"></i>
        </el-tooltip>
      </div>
      <p class="tips-info">{{ $t('config-manager::operate-config::title-sub') }}</p>
    </div>

    <el-form :model="form" ref="from" label-width="0px">
      <el-form-item
        label=""
        prop="predictRate"
        :placeholder="$t('config-manager::operate-config::placehodler')"
        :rules="[
          { required: true, message: $t('config-manager::operate-config::placehodler') },
          { type: 'number', message: $t('config-manager::operate-config::placehodler-number') },
        ]"
      >
        <el-input-number
          class="input-item"
          v-model="form.predictRate"
          controls-position="right"
          :min="0"
          :max="100"
        ></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="btnLoading" size="medium" class="save-btn" @click="onSave">
          {{ $t('config-manager::operate-config::save') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import rateModal from '../components/change-rate-modal'
import { getPredictRate, updatePredictRate } from '@/server/system'
export default {
  components: {
    rateModal,
  },
  data() {
    return {
      form: {
        predictRate: '',
      },
      btnLoading: false,
      loading: false,
    }
  },
  created() {
    this.getRate()
  },
  methods: {
    async onSave() {
      this.btnLoading = true
      const { data } = await updatePredictRate({
        key: 'predict_rate',
        value: this.form.predictRate,
        type: this.$store.state.user.merchantId,
        status: 1,
      })
      this.btnLoading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
      }
    },
    async getRate() {
      this.loading = true
      const { data } = await getPredictRate()
      this.loading = false
      if (data.code === this.$code) {
        this.form.predictRate = data.data.value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title-header {
  padding: 20px 0 8px;
  font-size: 16px;
  color: #010517;
  line-height: 20px;
}
.input-item {
  width: 200px;
  margin-top: 14px;
}
.save-btn {
  margin-top: 30px;
}
.tips-info {
  color: #666666;
}
</style>
